import { render, staticRenderFns } from "./MappingCabang.vue?vue&type=template&id=2875ed1a"
import script from "./MappingCabang.vue?vue&type=script&scoped=true&lang=js"
export * from "./MappingCabang.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./MappingCabang.vue?vue&type=style&index=0&id=2875ed1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports